/* eslint-disable react/no-unescaped-entities */

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CTAFinal({ onCtaClick }) {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 overflow-hidden" data-testid="cta-final-section">
      <div className="absolute inset-0">
        <img src="/centers/img_5504.jpg" alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black" />
        <div className="absolute inset-0 bg-stripes opacity-50" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative max-w-5xl mx-auto px-6 lg:px-12 text-center"
      >
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="h-px w-12 bg-[#FFD60A]" />
          <span className="font-mono text-xs tracking-[0.4em] text-[#FFD60A] uppercase">Dernière étape</span>
          <span className="h-px w-12 bg-[#FFD60A]" />
        </div>

        <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-white uppercase leading-[0.95]">
          Prêt à lancer votre activité <br className="hidden md:block" />
          de <span className="text-[#FFD60A]">reprogrammation</span> ?
        </h2>

        <p className="mt-8 text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto leading-relaxed">
          Rejoignez Horsepower Academy et bénéficiez d'une méthode complète alliant expertise technique et développement commercial.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => onCtaClick("call_booking", { campaign: "cta-final" })}
            className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#FFD60A] text-black font-bold uppercase tracking-wider hover:bg-yellow-300 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(255,214,10,0.35)]"
            data-testid="cta-final-primary"
          >
            Réserver un appel découverte
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </motion.div>
    </section>
  );
}
